import axios from 'axios'
import lodash from 'lodash'
import qs from 'qs'

import store from '@/store'
import errorHandler from '@/errorHandler'


class ApiError extends Error {
  constructor(code, status, message) {
    super(message)
    this.code = code
    this.status = status
    this.message = message
  }
}


export default {

  install(Vue, config) {

    axios.interceptors.response.use(null, async error => {
      if (error.response.data) {
        const { code, status, message } = error.response.data
        error = new ApiError(code, status, message)
      }
      errorHandler(error)
      return Promise.reject(error)
    })

    lodash.merge(axios.defaults, {

      baseURL: config.api.baseURL,

      paramsSerializer: params => qs.stringify(params),

      transformRequest: [(data, headers) => {
        const { token } = store.state.auth
        headers['Content-Type'] = 'application/json'
        if (token) {
          headers['Authorization'] = `Bearer ${token}`
        }
        return JSON.stringify(data)
      }],

      transformResponse: [data => {
        return data ? JSON.parse(data) : null
      }],

    })

    axios.interceptors.request.use(
      config => {

        const { activityId } = store.state.activity

        if(!config.params) {
          config.params = {};
        }

        if (activityId > 0 && !config.params.activityId) {
          config.params.activityId = activityId
        }

        return config;
      }
    );

    Vue.prototype.$isApiError = error => {
      return error instanceof ApiError
    }

    Vue.prototype.$axios = axios
  }

}
